type Token = {
  name: string;
  symbol: string;
  icon: string | null;
  flags: object;
};

export type DefiBalance = {
  protocolSymbol: string;
  protocolName: string;
  positionType: string;
  quantity: number;
  value: number;
  price: number;
  changes: {
    absolute_1d: number;
    percent_1d: number;
  };
  token: Token;
  flags: object;
  updatedAt: string;
  chainId: string;
};

type TokenTransfer = {
  name: string;
  symbol: string;
  icon?: string;
  quantity: number;
  value?: number;
  price?: number;
  sender: string;
  recipient?: string;
};

export type DefiTransaction = {
  id: string;
  timestamp: number;
  place: string;
  status: string;
  chainId: string;
  type: string;
  date: string;
  tokensIn: TokenTransfer[];
  tokensOut: TokenTransfer[];
  address: string;
  txHash: string;
  accountName: string;
  fee: {
    cost: number;
    currency: string;
  };
};
